function RichardsonLogin() {}

RichardsonLogin.events = {
    is_init: true,

    init: function() {
        var that = this;
        if (RichardsonLogin.events.is_init) {
            $(".richardson-footer").on('click', '.user-login', RichardsonLogin.events.onClickLogin);
            $("#richardson-user-login").on('click', '.submit-login', RichardsonLogin.events.handleUserLogin);
            $("#richardson-user-login").on('keyup', 'input[name="password"]', function(event) {
                /* Act on the event */
                if ($(this).hasClass('uk-form-danger')) {
                    $(this).removeClass('uk-form-danger');
                }

                var errEl = $(this).parent().parent().find(".uk-alert-danger");

                if (errEl.length !== 0) {
                    errEl.remove();
                }
            });

            $("#richardson-user-login").on('keyup', 'input[name="email"]', function(event) {
                /* Act on the event */
                if ($(this).hasClass('uk-form-danger')) {
                    $(this).removeClass('uk-form-danger');
                }

                var errEl = $(this).parent().parent().find(".uk-alert-danger");

                if (errEl.length !== 0) {
                    errEl.remove();
                }
            });

            RichardsonLogin.events.is_init = false;
        }
    },

    onClickLogin: function() {
        $("#r-login").trigger('reset')
        $("#r-login input[name='password']").removeClass('uk-form-danger');
        $("#r-login input[name='email']").removeClass('uk-form-danger');
        UIkit.modal("#richardson-user-login").show();
    },

    handleUserLogin: function() {
        var email = $("#r-login input[name='email']").val();
        var password = $("#r-login input[name='password']").val();

        var tmpl = document.getElementById("m-error-message").innerHTML;

        if (email.length === 0) {
            var render = Mustache.render(tmpl, {message: "Email is required"});
            $("#r-login input[name='email']").addClass('uk-form-danger');
            $("#r-login input[name='email']").parent().parent().append(render);
        }

        if (password.length === 0) {
            var render = Mustache.render(tmpl, {message: "Password is required"});
            $("#r-login input[name='password']").addClass('uk-form-danger');
            $("#r-login input[name='password']").parent().parent().append(render);
        }
        UIkit.modal("#richardson-loading-modal").show();
        RichardsonLogin.events.postUserLogin(email, password);
    },

    postUserLogin: function(email, password, source) {
        if (email.trim().length === 0 || password.trim().length === 0) { return; }

        var data = {
            email: email,
            password: password
        };

        if (typeof $.ajaxSettings.headers !== "undefined") {
            delete $.ajaxSettings.headers["X-CSRF-TOKEN"];
        }

        $.ajax({
            url: ub.config.magentoURL + "/uniform-builder/index/loginUser",
            data: JSON.stringify(data),
            type: "POST",
            crossDomain: true,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            headers: {
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest"
            },
            success: function (response) {
                _.delay(function() {
                    RichardsonLogin.events.onSuccessLogin(response);
                }, 500);
            },

            error: function(err) {
                RichardsonLogin.events.onError();
            }
        });
    },

    onSuccessLogin: function(response) {
        if (typeof response !== "undefined") {
            if (response.status) {
                // Save USer
                window.ub.user = {
                    id: parseInt(response.id),
                    fullname: response.fullname,
                    firstName: response.firstName,
                    lastName: response.lastName,
                    email: response.email,
                    type: response.type,
                    origin: "design-preview"
                };
                
                ub.id = response.id;

                ub.current_material.settings.userFullName = response.fullname;

                PdfPanel.regeneratePdf(function() {
                    // Change Login to Save Design
                    ub.funcs.afterLogin();
                    RichardsonSkin.funcs.setupFooter();
                    DesignPreview.events.showSavedDesign();
                    DesignPreview.events.reIniateSavingOptionUI();
                    
                    DesignPreview.events.hideLoader();
                    RichardsonSkin.events.reInitNextAndPrev();
                });
            } else {
                DesignPreview.events.hideLoader();
                var render = DesignPreview.events.showAlertMessage("Invalid email or password", "danger");

                $(".login-container .message-container").html("");
                $(".login-container .message-container").html(render);

                _.delay(function() {
                    $(".login-container .message-container").html("");
                }, 5000);
            }
        } else {
            DesignPreview.events.hideLoader();
            var renderErrorMessage = DesignPreview.events.showAlertMessage("Invalid response. Please reload and try again!", "danger");

            $(".login-container .message-container").html("");
            $(".login-container .message-container").html(renderErrorMessage);

            _.delay(function() {
                $(".login-container .message-container").html("");
            }, 5000);
        }
    },

    onError: function() {
        var message = "Something went wrong, please try again.";
        ub.funcs.showNotification(message, "danger", 5000);
        DesignPreview.events.hideLoader();
    }
};